import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the AbsoluteValuePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'absoluteValue',
})
export class AbsoluteValuePipe implements PipeTransform {
  transform(value: number, ...args) {
    return Math.abs(Number(value));
  }
}



// WEBPACK FOOTER //
// ./src/pipes/absolute-value/absolute-value.ts